import { PaymentStatusUI } from '~entities/payment';

import { MoneyPh } from '~shared/ui/money-ph';

import { createColumnHelper } from '@tanstack/react-table';

import type { PaymentTableData } from '../model/payments-table-data';

const columnHelper = createColumnHelper<PaymentTableData>();

type Props = {
  name?: string;
  merchantName?: string;
};

export const StoreInfo = ({ name, merchantName }: Props) => {
  if (!name) {
    return <span>–</span>;
  }
  return (
    <div>
      <span
        className={`
          inline-block max-w-full overflow-hidden text-ellipsis
          whitespace-nowrap
        `}
        title={name}
      >
        {name}
      </span>
      <br />
      <span
        className={`
          inline-block max-w-full overflow-hidden text-sm text-ellipsis
          whitespace-nowrap text-black/50
        `}
        title={merchantName}
      >
        {merchantName}
      </span>
    </div>
  );
};

export const columns = [
  columnHelper.accessor(
    ({ paymentStatus, paymentTimestampUTC }) => ({
      paymentStatus,
      paymentTimestampUTC,
    }),
    {
      id: 'status',
      cell: (data) => <PaymentStatusUI {...data.getValue()} />,
      header: 'Status',
    }
  ),
  columnHelper.accessor(
    ({ agreementId, transactionId }) => ({ agreementId, transactionId }),
    {
      id: 'transactionId',
      cell: (data) => {
        const { transactionId, agreementId } = data.getValue();
        return (
          <div className="max-w-full">
            {transactionId}
            <br />
            <span className="max-w-full text-black/50">
              {agreementId || '–'}
            </span>
          </div>
        );
      },

      header: () => (
        <span>
          Transaction&nbsp;ID&nbsp;&
          <br />
          Agreement&nbsp;ID
        </span>
      ),
    }
  ),
  columnHelper.accessor((row) => row.pos, {
    id: 'pos',
    cell: (data) => (
      <div className="w-full">
        <StoreInfo {...data.getValue()} />
      </div>
    ),
    header: () => <span>Store name</span>,
  }),
  columnHelper.accessor((row) => row.financedAmount, {
    id: 'financedAmount',
    cell: (data) => (
      <div className="flex justify-end">
        <MoneyPh value={data.getValue()} />
      </div>
    ),
    header: () => <div className="flex-1 text-right">Financed amount</div>,
  }),
  columnHelper.accessor((row) => row.subsidyAmount, {
    id: 'zeroRateSubsidy',
    cell: (data) => {
      const subsidy = data.getValue();
      return (
        <div className="flex justify-end">
          {subsidy ? '–' : ''}
          <MoneyPh value={subsidy} />
        </div>
      );
    },
    header: () => <div className="flex-1 text-right">Subsidy</div>,
  }),
  columnHelper.accessor((row) => row.settledAmount, {
    id: 'settledAmount',
    cell: (data) => (
      <div className="flex justify-end">
        <MoneyPh value={data.getValue()} />
      </div>
    ),
    header: () => <div className="flex-1 text-right">Settled amount</div>,
  }),
];

export enum ColumnId {
  STATUS = 'status',
  AGREEMENT_ID = 'transactionId',
  POS = 'pos',
  FINANCED_AMOUNT = 'financedAmount',
  SETTLED_AMOUNT = 'settledAmount',
  ZERO_RATE_SUBSIDY = 'zeroRateSubsidyAmount',
}
